// extracted by mini-css-extract-plugin
export default {"brand":"BrandInsights_brand__ufeM4","brand_specs":"BrandInsights_brand_specs__GWu2t","partition":"BrandInsights_partition__Fwb5b"};